<div class="rename-sim-wrapper">
  <mat-form-field
    style="margin-bottom: 12px; min-width: 300px"
    appearance="fill"
  >
    <mat-label>Simulation name</mat-label>
    <input matInput type="text" #name [value]="simulationName" />
  </mat-form-field>

  <div class="horizontal-wrapper">
    <button mat-stroked-button [color]="'warn'" (click)="cancel()">
      Cancel
    </button>
    <button
      mat-raised-button
      [color]="'primary'"
      (click)="renameSimulation(name.value)"
    >
      Rename
    </button>
  </div>
</div>
